import React, { useMemo,useRef } from "react";
import { Card } from "react-bootstrap";
import { HistoryFilter } from "./history-filter/HistoryFilter";
import { HistoryTable } from "./history-table/HistoryTable";
import { useHistoryUIContext } from "./HistoryUIContext";
import { CSVLink } from "react-csv";
import { TransactionCounter } from "./TransactionCounter";

export function HistoryCard({
  isLoading,
  counterList,
  fundCounterList,
  transactionList,
  handleFilterValues,
  filterValues,
  loadingExportButton,
  exportCSVButton,
  handleReset,
  transactionListExport,
  handleExportButton,
  transactionListTotalCount,
  currentPage,
  setCurrentPage,
}) {
  const historyUIContext = useHistoryUIContext();
  const historyUIProps = useMemo(() => {
    return {
      ids: historyUIContext.ids,
      queryParams: historyUIContext.queryParams,
      setQueryParams: historyUIContext.setQueryParams,
      openReceiptDialog: historyUIContext.openReceiptDialog,
    };
  }, [historyUIContext]);
const myRef = useRef(null);
  const onhandleReset = () => {
    myRef.current.click();
  };
  return (
    <>
      <TransactionCounter
        counterList={counterList}
        fundCounterList={fundCounterList}
      />
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4  d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">Transactions</span>
          </h3>
          <button
            type="button"
            className="btn btn-secondary btn-lg"
            // disabled={false}
            onClick={onhandleReset}
          >
            Reset
            {/* {loadingExportButton && (
              <span className="ml-1 mr-3 spinner spinner-white"></span>
            )} */}
          </button>
          <button
            className="btn btn-light-primary btn-lg"
            disabled={false}
            onClick={handleExportButton}
          >
            Export
            {loadingExportButton && (
              <span className="ml-1 mr-3 spinner spinner-white"></span>
            )}
          </button>
          <CSVLink
            ref={exportCSVButton}
            className="btn btn-light-primary btn-lg d-none"
            headers={[
              { label: "Transaction ID", key: "id" },
              { label: "Sender ID", key: "senderId" },
              { label: "Receiver ID", key: "receiverId" },
              { label: "Amount", key: "amount" },
              { label: "Commission", key: "commission" },
              { label: "Address 1", key: "address_1" },
              { label: "Address 2", key: "address_2" },
              { label: "City", key: "city_name" },
              { label: "State", key: "state_name" },
              { label: "Country", key: "country_name" },
              { label: "Postal Code", key: "zip_code" },
              { label: "Transaction Date", key: "date" },
              { label: "Confirmation ID", key: "confirmation_id" },
              { label: "Confirmation Date", key: "confirmation_date" },
              { label: "IP", key: "ip_country" },
              { label: "SC Transaction ID", key: "sc_transactionId" },
              { label: "SC Transaction Type", key: "sc_type" },
              { label: "Note", key: "other" },
              { label: "Accept/Reject Note", key: "accept_reject_note" },
              { label: "Tranasction Status", key: "transaction_status.name" },
            ]}
            data={transactionListExport}
            filename={`transactions-${new Date().getTime()}.csv`}
          >
            Export
          </CSVLink>
        </Card.Header>
        <Card.Body>
          <HistoryFilter
            filterValues={handleFilterValues}
            handleReset={handleReset}
            myRef={myRef}
          />
          <HistoryTable
            isLoading={isLoading}
            transactionList={transactionList}
            filterValues={filterValues}
            transactionListTotalCount={transactionListTotalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </Card.Body>
      </Card>
    </>
  );
}
